export const dataPeople = [
    {
        "id": "mala",
        "name": "Mała metalowa dziewczynka"
    }, {
        "id": "maly",
        "name": "Mały metalowy chłopiec"
    }, {
        "id": "stara",
        "name": "Stara osowiała staruszka"
    }, {
        "id": "halina",
        "name": "Halina"
    }, {
        "id": "krystyna",
        "name": "Krystyna"
    }, {
        "id": "bozena",
        "name": "Bożena"
    }, {
        "id": "men",
        "name": "Mężczyzna"
    }, {
        "id": "aktor",
        "name": "Aktor"
    }, {
        "id": "prezenterka",
        "name": "Prezenterka"
    }, {
        "id": "radio",
        "name": "Radio"
    }, {
        "id": "monika",
        "name": "Monika"
    }, {
        "id": "na",
        "name": "Nie przypisany"
    }
]

export const dataBeep = {
    "source": "./beep-short.mp3"
}